import React from "react";

// Import components
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Hero from "../components/sections/Hero";
import Features from "../components/sections/Features";
import Stats from "../components/sections/Stats";
import CTA from "../components/sections/CTA";
import LandingSections from "../components/sections/LandingSections";

const LandingPage: React.FC = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Stats />
        <LandingSections />
        <CTA />
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;
